import { ExpandedLinkElement, ImageElement } from '@all-hands-hq/plex-graphql-schema';
import React from 'react';
import { Path } from 'slate';
import { ReactEditor } from 'slate-react';

import { inlineNodeAsLink } from '../internal/withLinks';
import { AttachmentMenu } from './AttachmentMenu';

type Props = {
  editor: ReactEditor;
  node: ExpandedLinkElement | ImageElement;
  path: Path;
  isPrimaryLink: boolean;
  onChangePrimaryLink: (primaryLink: string) => void;
};

export const AttachmentMenuContainer = ({
  editor,
  node,
  path,
  isPrimaryLink,
  onChangePrimaryLink,
}: Props): React.ReactElement => {
  const { url } = node;

  return (
    <AttachmentMenu
      url={url}
      viewAction="open_in_new_tab"
      isPrimaryLink={isPrimaryLink}
      onSetAsPrimaryLink={(): void => {
        onChangePrimaryLink(url);
      }}
      onInline={(): void => {
        inlineNodeAsLink(editor, node, path);
        ReactEditor.focus(editor);
      }}
    />
  );
};
